const validatePhoneNumber = input_str => {
  var re = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;

  return re.test(input_str);
};
export default validatePhoneNumber;
